export default function ColorBox() {

var colorList = ["#000000", "#FF0000", "#FF5B00","#FF8700", "#FFAD00", "#FFD000", "#FFE000", "#EAEF00", "#DBFF00", "#4CB200", "#008000"]

    let style = {
        container: {
            "display": "flex",
        },
        box: {
            width: "100px",
            "text-align": "center",
            "line-height": "75px",
            "font-size": "30px"
        }

    }

    function assignBoxStyle(colorIndex) {
        let color = colorList[colorIndex];
        return Object.assign({}, style.box, { "backgroundColor": color })
    }
    return (
        <div style={style.container}>
            <div style={assignBoxStyle(0)}>0</div>
            <div style={assignBoxStyle(1)}>1</div>
            <div style={assignBoxStyle(2)}>2</div>
            <div style={assignBoxStyle(3)}>3</div>
            <div style={assignBoxStyle(4)}>4</div>
            <div style={assignBoxStyle(5)}>5</div>
            <div style={assignBoxStyle(6)}>6</div>
            <div style={assignBoxStyle(7)}>7</div>
            <div style={assignBoxStyle(8)}>8</div>
            <div style={assignBoxStyle(9)}>9</div>
            <div style={assignBoxStyle(10)}>10</div>
        </div>
    );
}